$(document).ready(function () {

    // Parse the variant details JSON
    const variantDetailsScript = document.getElementById("variant_details");
    if (!variantDetailsScript) {
        console.error("Variant details script not found!");
        return;
    }
    const variantDetails = JSON.parse(variantDetailsScript.textContent);
    const productVariants = variantDetails.product_variants;
    const digitizedBtn = $(".digitized-addtocart-btn");

    $(document).on('click', '.pdp-customize-me-btn', function (event) {
        event.preventDefault();
        const __this = $(this);
        // Variant info is still refreshing, so the href may still hold the previous variant
        if (__this.hasClass('loader')) return;
        const buttonURL = __this.attr('href');
        const productInfo = __this.closest('product-info');

        const selectedQty = parseInt($('.quantity_selector--wrapper .customize_wrapper .quantity__input[name="quantity"]').val(), 10);
        const selectedVariantId = $(this).closest('form').find('input[name="id"]').val();
        const variant = productVariants.find(v => v.id === selectedVariantId);
        // console.log('variant',variant);

        // Size option the customer must choose (see require_size in product-variant-picker.liquid)
        const hasRequiredOption = productInfo.find('variant-radios fieldset[data-option-required]').length > 0;

        if (hasRequiredOption) {
            if (!isRequiredVariantOptionSelected(productInfo[0])) {
                console.log('Not the correct variant.');
                __this.addClass('variant-not-selected');
                digitizedBtn.addClass('variant-not-selected');
                return;
            }

            console.log('Correct Variant has been selected!');
            __this.removeClass('variant-not-selected');
            digitizedBtn.removeClass('variant-not-selected');

            if (variant) {
                const availableInventory = parseInt(variant.inventory_qty, 10);
                // Check if the selected quantity exceeds available inventory
                if (selectedQty > availableInventory && variant.inventory_management == 'shopify' && variant.inventory_policy != 'continue') {
                    const message = availableInventory === 1
                        ? `Only 1 unit of this variant is available.`
                        : `Only ${availableInventory} units of this variant are available.`;
                    $('.customize_wrapper-btn-errors').html(`<span>${message}</span>`);
                    setTimeout(function(){
                        $('.customize_wrapper-btn-errors').html('');
                    },5000);
                    return;
                }
            }

            console.log('Second MAIN REDIRECT');
            location.href = buttonURL;
        } else {
            console.log('MAIN REDIRECT');
            location.href = buttonURL;
        }
    });

    // ADD TO CART BUTTON
    $(document).on('click', '.product-form__submit', function (event) {
        event.preventDefault();
        const __this = $(this);
        const productInfo = __this.closest('product-info');

        // Size option the customer must choose (see require_size in product-variant-picker.liquid)
        const hasRequiredOption = productInfo.find('variant-radios fieldset[data-option-required]').length > 0;

        if (hasRequiredOption) {
            if (!isRequiredVariantOptionSelected(productInfo[0])) {
                console.log('Not the correct variant.');
                __this.addClass('variant-not-selected');
                digitizedBtn.addClass('variant-not-selected');
                return;
            }

            console.log('Correct Variant has been selected!');
            __this.removeClass('variant-not-selected');
            digitizedBtn.removeClass('variant-not-selected');
            // __this.closest('.tab-button').find('.product-form__submit[name=add]').trigger('click');
            const formData = __this.closest('form').serialize();
            pdp_add_to_cart(formData);
        } else {
            const formData = __this.closest('form').serialize();
            pdp_add_to_cart(formData);
            return false;
        }
    });

    function pdp_add_to_cart(formData) {
        // console.log('form data',formData);
        let productData = formData;
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: productData,
            dataType: 'json', 
            success: function (data) {
                pdp_cart_update();
            }
        });
    }

    function pdp_cart_update() {
        fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
            const cartid = 'CartDrawer';
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.querySelector('#CartDrawer');
            const source = html.getElementById(cartid);
            if (source && destination) destination.innerHTML = source.innerHTML;

            // Re-initialize the collection slider on the freshly rendered HTML
            if (typeof collectionSlider === 'function') {
                collectionSlider('.cart_drawer--collection-box--wrapper');
            }
            if (typeof initCartDrawerSlider === 'function') {
                setTimeout(initCartDrawerSlider, 350);
            }

            $.ajax({
                url: '/?section_id=cart-icon-bubble',
                type: 'GET',
                dataType: 'html',
                success: function (itemcount) {
                    $('.drawer').removeClass('is-empty');
                    $("#cart-icon-bubble").html($(itemcount).html());
                    // Open the cart drawer properly instead of clicking the icon
                    const cartDrawerEl = document.querySelector('cart-drawer');
                    if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
                        cartDrawerEl.open();
                    } else { 
                        $(".cart-count-bubble").trigger("click");
                    }
                    console.log('cart updated');
                }
            });
        });
    }
});
